/**
 * Initial state factory for the "group" (org) Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. Holds the current org's data
 * and profile, the user's org lists, membership/moderation lists (join
 * requests, banned users), followed channels, and the group's own feed posts.
 */
export default () => ({
  orgTypes: [],
  orgData: {},
  myOrgList: [],
  otherOrgList: [],
  serchMembers: [],
  numFollowersChannel: null,
  orgPosts: [],
  isLoading: false,
  joinRequests: [],
  noSearchMembers: null,
  noSearchOrgs: null,
  currentOrgProfile: null,
  bannedUsersList: [],
  followingChannels: [],
  getPrivacyPoli:[], 
  getTermsCond:[],
});
